<template>
  <el-dialog width="800px" :visible.sync="isUpdateScore" :show-close="false" :title="updateScoreTitle"
             :close-on-click-modal="false" :close-on-press-escape="false">
    <p style="margin: auto;width: 550px;color: red;">注:请准确填写高考成绩及位次，成绩及位次确认后，点击“立即保存”，保存后，不可修改!</p>
    <p style="margin: auto;width: 550px;color: red;padding-top: 10px;">后续所做的全部志愿方案都以考生确认的真实高考成绩为准。</p>
    <el-form ref="elForm" :model="updateScoreForm"  label-width="80px" style="margin: auto;width: 520px;padding-top: 20px;">
      <el-form-item label="高考成绩" prop="score">
        <el-input class="item-input" v-model="updateScoreForm.score" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="高考位次" prop="precedence">
        <el-input class="item-input" v-model="updateScoreForm.precedence" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="saveStuScore()">立即保存</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import { request } from "@/util/request.js"
import { miniThrottle } from '@/util'

export default {
  data() {
    return {
      infos: {},
      isUpdateMajor: false,
      updateScoreTitle:"高考成绩确认",
      updateScoreForm: {},
      isUpdateScore: false,
    }
  },

  created() {
    this.infos = this.$route.params.info
    this.infos = JSON.parse(sessionStorage.getItem("user"))

    this.getUpdateMsgStatus();
  },
  mounted() {},
  methods: {
    //获取修改选科条件
    getUpdateMsgStatus(){
      if(this.infos.userType === 4){
        this.getStu();
        request({
          method: 'get',
          url: 'students/getUpdateMsgStatus',
          params: {
            stuId: this.infos.stuId
          }
        }).then(res => {
          if(res.showMajor){
            this.isUpdateMajor= true;
          }else if(res.showScore){
            this.isUpdateScore= true;
          }
        })
      }
    },
    getStu () {
      request({
        method: 'get',
        url: 'students/getStu',
        params: {
          Id: this.infos.userId
        }
      }).then(res => {
        this.updateScoreForm.id = res.data.id;
      })
    },
    saveStuScore(){
      if (this.isUndefinedOrNull(this.updateScoreForm.score) || this.isUndefinedOrNull(this.updateScoreForm.precedence) || this.updateScoreForm.score == '' || this.updateScoreForm.precedence == '') {
        this.$message({
          message: '请输入高考分数和位次',
          type: 'error'
        });
        return;
      }
      this.updateScoreForm.disabledScore = true;
      request({
        method: 'post',
        url: 'students/saveOrUpdateArchives',
        data: this.updateScoreForm
      }).then(res => {
        if (res.code == 0) {
          this.$message({
            message: '操作成功！',
            type: 'success'
          });
          this.isUpdateScore = false;
          this.$emit('getStu')
        } else {
          this.$message({
            message: '操作失败~',
            type: 'error'
          });
        }
        return;
      })
    },
    isUndefinedOrNull(val) {
      return val === undefined || val === null;
    }
  }
}

</script>
